/* eslint-disable max-len */

import type { ApiLangPack } from '../api/types';

export const fallbackLangPackInitial = {
  WrongNumber: 'Wrong number?',
  SentAppCode: 'We\'ve sent the code to the **Chatzy** app on your other device.',
  'Login.JustSentSms': 'We have sent you a code via SMS. Please enter it above.',
  'Login.Header.Password': 'Enter Password',
  'Login.EnterPasswordDescription': 'You have Two-Step Verification enabled, so your account is protected with an additional password.',
  StartText: 'Please confirm your country code and enter your phone number.',
  'Login.PhonePlaceholder': 'Your phone number',
  'Login.Next': 'Next',
  'Login.QR.Login': 'Log in by QR Code',
  'Login.QR.Title': 'Log in to Chatzy by QR Code',
  'Login.QR.Help1': 'Open Chatzy on your phone',
  'Login.QR.Help2': 'Go to **Settings** > **Devices** > **Link Desktop Device**',
  'Login.QR2.Help2': 'Go to **Settings** → **Devices** → **Link Desktop Device**',
  'Login.QR.Help3': 'Point your phone at this screen to confirm login',
  'Login.QR.Cancel': 'Log in by phone Number',
  YourName: 'Your Name',
  'Login.Register.Desc': 'Enter your name and add a profile picture.',
  'Login.Register.FirstName.Placeholder': 'First Name',
  'Login.Register.LastName.Placeholder': 'Last Name',
  'Login.SelectCountry.Title': 'Country',
  lng_country_none: 'Country not found',
  PleaseEnterPassword: 'Enter your new password',
  PHONE_NUMBER_INVALID: 'Invalid phone number',
  PHONE_CODE_INVALID: 'Invalid code',
  PASSWORD_HASH_INVALID: 'Incorrect password',
  PHONE_PASSWORD_FLOOD: 'Limit exceeded. Please try again later.',
  PHONE_NUMBER_BANNED: 'This phone number is banned.',
  'EmptyChat.Appearance.System': 'Empty Chat Appearance System',
  'Chat.EmptyChat': 'Empty Chat',
  ProfileJoinGroup: 'Join Group',
  'Notification.JoinedChat': '%@ joined the group',
  lng_context_copy_text: 'Copy',
  lng_context_report_msg: 'Report',
  lng_context_copy_message_link: 'Copy Link',
  'Share.Link.Copied': 'Copied to Clipboard',
  'Notification.VoiceChatStartedChannel': 'Live stream started',
  'Notification.VoiceChatEnded': 'Live stream finished',
  'GroupInfo.LabelOwner': 'Owner',
  ProfileJoinChannel: 'Join',
  lng_view_button_user: 'Send Message',
  'StoryList.SavedEmptyState.Title': 'No posted stories',
  'GroupInfo.LabelAdmin': 'admin',
  'GroupInfo.Title': 'Group Info',
  'GroupInfo.InviteLinks': 'Invite Links',
  ForumToggleDescription: 'The group chat will be divided into topics created by admins or users.',
  lng_info_user_title: 'User Info',
  StickersName: 'Stickers and Emoji',
  TelegramFaq: 'Chatzy Faq',
  'Settings.MyStories': 'My Stories',
  OpenUrlTitle: 'Open Link',
  OpenUrlAlert2: 'Do you want to open %1$s?',
  'ReportPeer.Report': 'Report',
  BlockUser: 'Block user',
  VideoCall: 'Video call',
  AddContact: 'Add to contacts',
  BotHelp: 'Help',
  'Bot.Stop': 'Stop',
  StartVoipChat: 'Start Video chat',
  ViewDiscussion: 'View Discussion',
  'Weekday.Saturday': 'Saturday',
  'Weekday.Sunday': 'Sunday',
  'Weekday.Monday': 'Monday',
  'Weekday.Tuesday': 'Tuesday',
  'Weekday.Wednesday': 'Wednesday',
  'Weekday.Thursday': 'Thursday',
  'Weekday.Friday': 'Friday',
  'Weekday.ShortSaturday': 'Sat',
  'Weekday.ShortSunday': 'Sun',
  'Weekday.ShortMonday': 'Mon',
  'Weekday.ShortTuesday': 'Tue',
  'Weekday.ShortWednesday': 'Wed',
  'Weekday.ShortThursday': 'Thu',
  'Weekday.ShortFriday': 'Fri',
  'Chat.Service.Group.UpdatedPinnedMessage1': '%1$@ pinned "%2$@',
  'Channel.MessagePhotoUpdated': 'Channel photo updated',
  lng_delete_for_everyone_hint: 'This will delete it for everyone in this chat',
  lng_media_file_empty: 'No files here yet',
  lng_media_link_empty: 'No shared links here yet',
  lng_media_song_empty: 'No music files here yet',
  lng_media_audio_empty: 'No voice messages here yet',
  AccDescrMentionDown: 'Go to next mention',
  lng_context_copy_image: 'Copy Image',
  lng_media_download: 'Download',
  MessageContainsEmojiPacks: 'This message contains emoji from **%d Packs**',
  lng_custom_emoji_used_sets: 'Sets of used emoji',
  'StickerPack.AddEmojiCount': 'Add %@ Emoji',
  StickersCopy: 'Copy link',
  lng_emoji_premium_restore: 'Restore',
  StartVoipChatPermission: 'Manage Video Chats',
  'Channel.EditAdmin.CannotEdit': 'You can not edit the rights of this admin.',
  'Conversation.ViewBot': 'VIEW BOT',
  SponsoredMessageInfo: 'What are sponsored messages?',
  SponsoredMessage: 'ad',
  HideAd: 'Hide',
  SponsoredMessageInfoDescription1: 'Unlike other apps, Chatzy never uses your private data to target ads. Sponsored messages on Chatzy are based solely on the topic of the public channels in which they are shown. This means that no user data is mined or analyzed to display ads, and every user viewing a channel on Chatzy sees the same sponsored messages.',
  SponsoredMessageInfoDescription2: 'Unlike other apps, Chatzy does not track whether you tapped on a sponsored message and does not profile you based on your activity. We also prevent external links in sponsored messages to ensure that third parties can’t spy on our users. We believe that everyone has the right to privacy, and technological platforms should respect that.',
  SponsoredMessageInfoDescription3: 'Chatzy offers a free and unlimited service to hundreds of millions of users, which involves significant server and traffic costs. In order to remain independent and stay true to its values, Chatzy developed a paid tool to promote messages with user privacy in mind. We welcome responsible advertisers at:',
  SponsoredMessageInfoDescription4: 'Sponsored Messages are currently in test mode. Once they are fully launched and allow Chatzy to cover its basic costs, we will start sharing ad revenue with the owners of public channels in which sponsored messages are displayed. Online ads should no longer be synonymous with abuse of user privacy. Let us redefine how a tech company should operate – together.',
  SponsoredMessageAlertLearnMoreUrl: 'https://ads.chatzy.ir',
  FilterAllChatsShort: 'All',
  BotInfoTitle: 'What can this bot do?',
  lng_info_bot_title: 'Bot Info',
  lng_new_contact_add: 'Add contact',
  lng_report_spam_and_leave: 'Report spam and leave',
  lng_call_start_video: 'Start Video',
  lng_call_end_call: 'End Call',
  lng_call_unmute_audio: 'Unmute',
  lng_call_screencast: 'Screencast',
  lng_call_status_waiting: 'waiting...',
  CallMessageIncoming: 'Incoming Call',
  CallMessageIncomingDeclined: 'Declined Call',
  lng_call_status_exchanging: 'exchanging encryption keys...',
  CallMessageIncomingMissed: 'Missed Call',
  CallMessageIncomingConferenceMissed: 'Missed Call',
  CallMessageOutgoing: 'Outgoing Call',
  'RequestAcces.Error.HaveNotAccess.Call': 'Chatzy needs microphone access so that you can make calls.',
  CallMessageWithDuration: '%1$s (%2$s)',
  UsernameAlso: 'also %1$s',
  ProfileStories: 'Posts',
  ProfileStoriesArchive: 'Story Archive',
  AddCaption: 'add a caption...',
  'Attachment.SendAsFile': 'Send as File',
  'Attachment.EnableSpoiler': 'Hide With Spoiler',
  'ChatList.Filter.AddToFolder': 'Add to folder...',
  MarkAsUnread: 'Mark as unread',
  'Time.AtDate': '%@',
  ReplyPrivately: 'Reply privately...',
  lng_report_story: 'Report story',
  StealthMode: 'Stealth Mode',
  CopyLink: 'Copy Link',
  lng_new_contact_share: 'Share my phone number',
  MobileHidden: 'Mobile hidden',
  'NewContact.Phone.Hidden.Text': 'Phone number will be **visible** once %@ adds you as a contact.',
  'AddContact.SharedContactExceptionInfo': 'You can make your phone visible to %@.',
  NewContact: 'New Contact',
  lng_report_reason_spam: 'Spam',
  lng_report_reason_violence: 'Violence',
  lng_report_reason_pornography: 'Pornography',
  lng_report_reason_child_abuse: 'Child abuse',
  'ReportPeer.ReasonCopyright': 'Copyright',
  lng_report_reason_other: 'Other',
  lng_report_reason_description: 'Description',
  lng_report_button: 'Report',
  lng_report_message_title: 'Report Message',
  'Notification.ChangedGroupName': '%@ changed the group name to "%@"',
  'Notification.Invited': '%@ invited %@',
  'Notification.Kicked': '%@ removed %@',
  'Conversation.ViewChannel': 'VIEW CHANNEL',
  HideSendersName: 'Hide Sender Name',
  ShowSendersName: 'Show Sender Name',
  ChangeRecipient: 'Change Recipient',
  NewMessageTitle: 'New Message',
  NewGroup: 'New Group',
  NewChannel: 'New Channel',
  JoinGroup: 'Join Group',
  FakeMessage: 'FAKE',
  'LastSeen.Offline': 'last seen a long time ago',
  BotStart: 'START',
  'Time.TodayAt': 'today at %@',
  'Time.MinutesAgo': '%@ minutes ago',
  lng_view_button_group: 'View group',
  'Conversation.DeleteMessagesFor': 'Delete for me and %@',
  'PeerInfo.PaneStories': 'Posts',
  'Conversation.GreetingText': 'Send a message or tap on the greeting below.',
  'Conversation.EmptyPlaceholder': 'No messages here yet...',
  'Notification.CreatedChannel': 'Channel created',
  'AccountSettings.Logout': 'Log Out',
  'ChatList.UnsupportedMessage': 'Message is not supported',
  'Chat.PlaceholderTextNotAllowed': 'Text not allowed',
  'Chat.SendAllowedContentText': 'The admins of this group only allow sending %1$@.',
  AttachAudio: 'Voice message',
  AttachGif: 'Gif message',
  'Story.CaptionShowMore': 'Show more',
  BotOpenPageTitle: 'Open page',
  BotOpenPageMessage: '**%1$s** would like to open its web app to proceed.\n\nIt will be able to access your **IP address** and basic device info.',
  NoStickers: 'No stickers yet',
  'StoryList.ArchivedEmptyState.Title': 'No Archived Stories',
  'Conversation.CloudStorageInfo.Title': 'Your Cloud Storage',
  'Conversation.ClousStorageInfo.Description1': '• Forward messages here to save them',
  'Conversation.ClousStorageInfo.Description2': '• Send media and files to store them',
  'Conversation.ClousStorageInfo.Description3': '• Access this chat from any device',
  'Conversation.ClousStorageInfo.Description4': '• Use search to quickly find things',
} as ApiLangPack;
